import Vue from 'vue'
import Vuex from 'vuex'
import UAParser from "ua-parser-js";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    Parser: UAParser(),
    isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i), //当前是不是wap
    isAndroid:
        ((navigator.userAgent.indexOf("Android") > -1 ||
                navigator.userAgent.indexOf("Adr") > -1) &&
            navigator.userAgent.indexOf("WeChat") > -1) ||
        ((navigator.userAgent.indexOf("Android") > -1 ||
                navigator.userAgent.indexOf("Adr") > -1) &&
            navigator.userAgent.indexOf("Huawei") > -1), //android终端
    isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //是否为ios终端
    isXiaoMi: navigator.userAgent.indexOf("XiaoMi") > -1,
    loginStyle: '登录',
    smsHref: '',//拉票进入的链接
    toTabClick: '',
  },
  getters: {
  },
  mutations: {
    changeloginStyle(state, n){
      state.loginStyle = n
    },
    changesmsHref(state, n){
      state.smsHref = n
    },
    changetoTabClick(state, n){
      state.toTabClick = n
    },
  },
  actions: {
  },
  modules: {
  }
})
